export enum GiftCurrency {
  COINS = "coins",
  DIAMONDS = "diamonds",
}
